const useUserData = () => {
  const userDetails = localStorage.getItem('user_data');
  if (!userDetails) return { userData: userDetails, error: true };
  return { userData: JSON.parse(userDetails), error: false };
};

export default useUserData;
